import { useEffect } from 'react'

/** `combo` like "mod+k", "alt+shift+t". mod = Cmd on macOS, Ctrl elsewhere. */
export function useHotkey(combo: string, handler: (event: KeyboardEvent) => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return
    const parts = combo.toLowerCase().split('+')
    const key = parts[parts.length - 1]
    const needMod = parts.includes('mod')
    const needShift = parts.includes('shift')
    const needAlt = parts.includes('alt')

    const onKeyDown = (event: KeyboardEvent) => {
      const mod = event.metaKey || event.ctrlKey
      if (needMod !== mod || needShift !== event.shiftKey || needAlt !== event.altKey) return
      if (event.key.toLowerCase() !== key && event.code.toLowerCase() !== `key${key}`) return
      event.preventDefault()
      handler(event)
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [combo, handler, enabled])
}
